import { showDialog, PlanLearnMoreDialog, ZoomWorkFlowAutomationDialog } from '@zoom/fe-billing-components';
import pcm from '@/global-install/global-pcm';

import {mapGetters} from "vuex";
import {translateToEn} from "@/plugins/i18n";

export default {
  data () {
    return {
      featureKeys: {
        zoomWorkFlowAutomation: 'ZOOM_WORK_FLOW_AUTOMATION_DIALOG'
      }
    };
  },
  computed: {
    ...mapGetters(['getSelectedPlans', 'learnMoreConfig']),
    trackingBasePlanName() {
      const selectedPlan = this.getSelectedPlans?.[0];
      return selectedPlan ? translateToEn(selectedPlan.planNameKey).toLowerCase() : '';
    },
    trackingAddAction() {
      const action = this.addTrackingText?.toLowerCase() || 'add';
      return this.learnMoreConfig.visible ? `learn more modal - ${action}` : action;
    }
  },
  methods: {
    async openDialogInCommon() {
      showDialog(pcm, ZoomWorkFlowAutomationDialog, { visible: true });
    },
    openPlanLearnMoreDialog(planType, planConfig = {}) {
      showDialog(
        pcm,
        PlanLearnMoreDialog,
        {
          visible: true,
          planType,
          planConfig: { ...planConfig },
        });
    },
  },
};
